import React from 'react';
import { Typography, Button, Grid, CircularProgress, IconButton, Tooltip, TextField, InputAdornment } from "@mui/material";
import QRCode from 'qrcode.react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import { Share as ShareIcon, ContentCopy as ContentCopyIcon, Check as CheckIcon } from '@mui/icons-material';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const styles = {
    gridItemHeader: {
        padding: 12,
        display: 'flex',
        justifyContent: 'center',
    },
    linkStyle: {
        color: 'black',
    },
    headingTypography: {
        textAlign: 'center',
        fontFamily: "'Open Sans', sans-serif",
        fontWeight: '600',
        color: '#1C1D1F',
    },
    mainDivStyle: {
        display: 'block',
        padding: '10px 20px 30px 20px',
        width: '100%',
        minHeight: 0,
        maxHeight: 'calc(100vh - 100px)', // leave space for header
        overflowY: 'auto', // make scrollable
        boxSizing: 'border-box',
    },
    gridContainerStyle: {
        textAlign: 'center',
    },
    gridItemContentStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start', // changed from 'center' to 'flex-start'
        height: '100%', // allow to fill parent height
    },
    contentTypography: {
        color: '#1C1D1F',
        fontFamily: "'Open Sans', sans-serif",
        fontWeight: '400',
        marginBottom: 20,
    },
    referralLinkDiv: {
        color: '#1C1D1F',
        margin: '10px 0',
        wordBreak: 'break-all',
    },
    buttonStyle: {
        marginTop: 10,
        backgroundColor: '#1C1D1F',
        color: 'white',
    },
};

class Referral extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            referralLink: '', memberName: '', isLoading:true,
            copied: false // add copied state
        };
    }

    componentDidMount() {
        this.fetchMemberName();
    }

    fetchMemberName = () => {
        const memberID = localStorage.getItem("memberID");
        const familyID = localStorage.getItem("familyID");

        const requestOptions = {
            method: "POST", headers: {
                "Content-type": "application/json; charset=UTF-8",
            }, body: JSON.stringify({
                memberID: memberID
            }),
        };

        fetch(`${baseURL}/utils/fetchMemberData.php`, requestOptions)
            .then((response) => response.json())
            .then(data => {
                const memberName = data.First;
                this.setState({
                    memberName: memberName,
                    referralLink: `https://form.typeform.com/to/Qr930SAI#member_first_name=${encodeURIComponent(memberName)}&ref_family_id=${encodeURIComponent(familyID)}`,
                },()=>{
                    this.setState({isLoading:false})
                });
            })
            .catch(error =>{ 
                console.error('Error fetching member name:', error)
                this.setState({ isLoading: false });
            });
    }

    copyToClipboard = () => {
        navigator.clipboard.writeText(this.state.referralLink)
            .then(() => {
                this.setState({ copied: true });
                setTimeout(() => this.setState({ copied: false }), 1500);
            })
            .catch(err => console.error('Could not copy text: ', err));
    }

    shareLink = () => {
        const { referralLink } = this.state;
        if (navigator.share) {
            navigator.share({
                title: 'BlckBx Referral',
                text: 'Get 10% off BlckBx personal assistance for a month with my referral link',
                url: referralLink,
            }).catch(() => {});
        } else {
            alert('Sharing is not supported in this browser.');
        }
    }

    render() {
        const { referralLink, isLoading, copied } = this.state;

        return (
            <div style={{ overflow: 'auto' }}>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item xs={1} sm={1} style={styles.gridItemHeader}>
                        <Link to={`/#`} style={styles.linkStyle}>
                            <ChevronLeft style={{ fontSize: '1.8rem' }} />
                        </Link>
                    </Grid>

                    <Grid item xs={10} sm={10} style={styles.gridItemHeader}>
                        <Typography variant="h6" component="div" style={styles.headingTypography}>
                         
                        </Typography>
                    </Grid>

                    <Grid item xs={1} sm={1}></Grid>
                </Grid>
                {isLoading ? (
                    <div style={{
                        ...styles.mainDivStyle,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start', // only horizontal centering
                        minHeight: 0
                    }}>
                        <CircularProgress style={{ color: '#1C1D1F' }} />
                    </div>
                ) : (
                    <div style={styles.mainDivStyle}>
                        {/* Remove the Grid container that centers content vertically */}
                        <Grid
                            container
                            spacing={2}
                            alignItems="flex-start"
                            justifyContent="center"
                            style={{ ...styles.gridContainerStyle, minHeight: '100%' }} // ensure container fills height
                        >
                            <Grid item xs={12} md={8} lg={6} style={{ ...styles.gridItemContentStyle, minHeight: '100%' }}>
                                <div
                                    style={{
                                        background: '#FFFFFF',
                                        borderRadius: '16px',
                                        padding: '16px',
                                        boxShadow: '0px 2px 8px rgba(0,0,0,0.04)',
                                        width: '100%',
                                        maxWidth: 420,
                                        margin: '0 auto 15px auto',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        component="div"
                                        style={{
                                            color: '#1C1D1F',
                                            fontFamily: "'EB Garamond', serif",
                                            fontWeight: 400,
                                            fontSize: '22px',
                                            textAlign: 'center',
                                            marginBottom: 18,
                                            letterSpacing: '0.2px',
                                        }}
                                    >
                                       Refer a friend to BlckBx and get 10% off your monthly subscription
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            color: '#555556',
                                            fontFamily: "'Open Sans', sans-serif",
                                            fontWeight: 400,
                                            fontSize: '15px',
                                            marginBottom: 18,
                                            textAlign: 'left',
                                            lineHeight: 1.6,
                                            width: '100%',
                                        }}
                                    >
                                        Tell your friends and work colleagues about BlckBx by sending them your personal link below, and if they sign up you <b>both get 10% off a month’s subscription!</b>
                                        <br /><br />
                                        <TextField
                                            value={referralLink}
                                            InputProps={{
                                                readOnly: true,
                                                style: {
                                                    background: '#F5F3F0',
                                                    borderRadius: '12px',
                                                    fontFamily: "'Open Sans', sans-serif",
                                                    fontSize: '17px',
                                                    color: '#1C1D1F',
                                                    height: 52,
                                                    paddingRight: 0,
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end" style={{ marginRight: 4 }}>
                                                        <Tooltip title={copied ? "Copied!" : "Copy"} arrow>
                                                            <IconButton
                                                                onClick={this.copyToClipboard}                                  
                                                                style={{
                                                                    backgroundColor: '#1C1D1F',
                                                                    color: 'white',
                                                                    marginRight: 2,
                                                                    borderRadius: 8,
                                                                    width: 38,
                                                                    height: 38,
                                                                }}
                                                            >
                                                                {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Share" arrow>
                                                            <IconButton
                                                                onClick={this.shareLink}
                                                                style={{
                                                                    backgroundColor: '#1C1D1F',
                                                                    color: 'white',
                                                                    borderRadius: 8,
                                                                    width: 38,
                                                                    height: 38,
                                                                }}
                                                            >
                                                                <ShareIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            fullWidth
                                            variant="outlined"
                                            sx={{
                                                mb: 2,
                                                '& .MuiOutlinedInput-root': {
                                                    paddingRight: 0,
                                                    borderRadius: '12px',
                                                    background: '#F5F3F0',
                                                    '& fieldset': {
                                                        borderColor: '#D1D5DB',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: '#B0B0B0',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#1C1D1F',
                                                    },
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '12px 16px',
                                                },
                                            }}
                                        />
                                        <br />
                                        <b>Who could you refer?</b>
                                        <ul style={{ margin: '10px 0 10px 18px', padding: 0, color: '#555556', fontSize: '15px' }}>
                                            <li><b>Colleagues at work </b>– get a bunch of you using BlckBx and we can talk to your employer to see if they’re interested in providing it as a benefit</li>
                                            <li><b>Friends visiting the UK and Europe</b> – we can help plan their trip end to end, make bookings and be on call whilst they’re over</li>
                                            <li><b>Friends or family who are snowed under</b> – actions speak louder than words, show you care by gifting a month of BlckBx.</li>
                                        </ul>
                                        <b>No lock in:</b> They will only be charged the first month and can end the subscription if they wish with no notice. Then if they stay it’s a month’s notice to cancel.
                                    </Typography>
                                    {/* <div style={{
                                        background: '#F8F8E4',
                                        borderRadius: '16px',
                                   
                                        marginBottom: 18,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                        <QRCode value={referralLink} size={128} level={'H'} />
                                    </div> */}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                )}
            </div>
        );
    }
}

export default Referral;
